var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found-container"},[_c('div',{staticClass:"not-found-content"},[_c('h1',[_vm._v("404 Not Found")]),_c('p',[_vm._v("抱歉，您访问的页面不存在。")]),_c('router-link',{staticClass:"back-home-btn",attrs:{"to":"/"}},[_vm._v("返回首页")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }